export default {
  currentPage: state => (father = null) => {
    const { route } = state;
    let data = null;

    if (father === null) {
      data = state.pages[route.params.city][route.name];
    } else {
      const index = state[father][route.params.city]
        .findIndex(speaker => speaker.path === route.params.name);
      data = state[father][index];
    }

    return data;
  },
  currentSpeaker: (state) => {
    const routeParams = state.route.params;
    let data = null;

    if (routeParams.city !== undefined) {
      const index = state.speakers[routeParams.city]
        .findIndex(speaker => speaker.path === routeParams.speaker);
      if (index !== -1) data = state.speakers[routeParams.city][index];
    }

    return data;
  },
  currentWorkshop: (state) => {
    const routeParams = state.route.params;
    let data = null;

    if (routeParams.city !== undefined) {
      const index = state.workshops[routeParams.city]
        .findIndex(workshop => workshop.path === routeParams.workshop);
      if (index !== -1) data = state.workshops[routeParams.city][index];
    }

    return data;
  },
  getSponsor: (state) => {
    const routeParams = state.route.params;
    let data = [];

    if (state.sponsor[routeParams.city].length > 0) {
      data = state.sponsor[routeParams.city];
    }

    return data;
  },
  contentReady: state => !state.inTransition && !state.loadingData,
  speakers: (state) => {
    if (typeof state.route === 'undefined') return {};
    return state.speakers[state.route.params.city];
  },
  workshops: (state) => {
    if (typeof state.route === 'undefined') return {};
    return state.workshops[state.route.params.city];
  },
  currentLinkUniverse: (state) => {
    if (typeof state.route === 'undefined') return '#';
    return state.urlButton[state.route.params.city];
  },
};
